module.exports = __webpack_public_path__ + "img/zhima.38c2e875.png";